// NomineeFormFields.js
import React, { useState } from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
  Form,
  Table,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import ConfirmationModal from "../../../Components/Modals/ConfirmationModal";

const NomineeFormFields = ({
  formik,
  colOverrides = {},
  isInModal,
  nomineeList,
  handleAddNominee,
  columns,
  handleEditNominee,
  setNomineeList,
  editIndex,
  setEditIndex,
  fileInputRef,
}) => {
  // state for confirmation modal
  const [confirm_modal, setConfirm_modal] = useState(false);
  const close_confirmModal = () => {
    setConfirm_modal(false);
  };
  const handleConfirmDelete = () => {
    setNomineeList((prev) => prev.filter((_, idx) => idx !== editIndex));
    close_confirmModal();
  };

  const relationshipOptions = [
    { label: "Father", value: 1 },
    { label: "Mother", value: 2 },
    { label: "Spouse", value: 3 },
    { label: "Son", value: 4 },
    { label: "Daughter", value: 5 },
    { label: "Brother", value: 6 },
    { label: "Sister", value: 7 },
  ];

  return (
    <>
      <div className="row m-0 p-0">
        <div className=" m-0 p-0 col-xxl-6 col-xl-9 col-lg-8 col-md-8 col-sm-12 col-12">
          <div className="mb-3">
            <span className="badge bg-success p-2 fs-p-sm text-uppercase">
              MANDATORY DETAILS
            </span>
          </div>
        </div>
      </div>
      <Form onSubmit={formik?.handleSubmit} className="p-0">
        <Row className="row m-0 p-0">
          <Col lg={6} className="ps-0">
            <FormGroup>
              <Label for="nominee_name">Name of Nominee *</Label>
              <Input
                type="text"
                name="nominee_name"
                id="nominee_name"
                className="form-control"
                placeholder="Enter name of nominee"
                value={formik.values.nominee_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.nominee_name && !!formik.errors.nominee_name
                }
              />
              <FormFeedback>{formik.errors.nominee_name}</FormFeedback>
            </FormGroup>
          </Col>
          <Col lg={6} className="ps-0 ps-lg-3">
            <FormGroup>
              <Label for="nominee_share">Share % *</Label>
              <Input
                type="number"
                name="nominee_share"
                id="nominee_share"
                className="form-control"
                placeholder="Enter share %"
                value={formik.values.nominee_share}
                onChange={(e) => {
                  // Allow only digits and max 10 characters
                  const value = e.target.value;
                  if (/^\d{0,3}$/.test(value)) {
                    formik.setFieldValue("nominee_share", value);
                  }
                }}
                onBlur={formik.handleBlur}
                invalid={Boolean(
                  formik.touched.nominee_share && formik.errors.nominee_share
                )}
              />
              {formik.touched.nominee_share && formik.errors.nominee_share && (
                <FormFeedback>{formik.errors.nominee_share}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Col lg={6} className="ps-0">
            <FormGroup>
              <Label for="nominee_relationship">Relationship *</Label>
              <Input
                type="select"
                name="nominee_relationship"
                id="nominee_relationship"
                className="form-control"
                placeholder="Enter relationship of nominee"
                value={formik.values.nominee_relationship}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.nominee_relationship &&
                  formik.errors.nominee_relationship
                }
              >
                <option value="" disabled>
                  Select Relationship
                </option>
                {relationshipOptions?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option?.label}
                  </option>
                ))}
              </Input>

              <FormFeedback>{formik.errors.nominee_relationship}</FormFeedback>
            </FormGroup>
          </Col>
          <Col lg={6} className="ps-0 ps-lg-3">
            <FormGroup>
              <Label for="nominee_email">Email *</Label>
              <Input
                type="text"
                name="nominee_email"
                id="nominee_email"
                className="form-control"
                placeholder="Enter email"
                value={formik.values.nominee_email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.nominee_email && formik.errors.nominee_email
                }
              />
              <FormFeedback>{formik.errors.nominee_email}</FormFeedback>
            </FormGroup>
          </Col>
          <Col lg={6} className="ps-0">
            <FormGroup>
              <Label for="nominee_mobile">Mobile No. *</Label>
              <Input
                type="text"
                name="nominee_mobile"
                id="nominee_mobile"
                className="form-control"
                placeholder="Enter mobile number"
                maxLength="10"
                value={formik.values.nominee_mobile}
                onChange={(e) => {
                  // Allow only digits and max 10 characters
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    formik.setFieldValue("nominee_mobile", value);
                  }
                }}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.nominee_mobile && formik.errors.nominee_mobile
                }
              />
              <FormFeedback>{formik.errors.nominee_mobile}</FormFeedback>
            </FormGroup>
          </Col>

          {!isInModal ? (
            <>
              <Col lg={6} className="ps-0 ps-lg-3">
                <FormGroup>
                  <Label for="nominee_address">Address *</Label>
                  <Input
                    type="text"
                    name="nominee_address"
                    id="nominee_address"
                    className="form-control"
                    placeholder="Enter address"
                    value={formik.values.nominee_address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_address &&
                      formik.errors.nominee_address
                    }
                  />
                  <FormFeedback>{formik.errors.nominee_address}</FormFeedback>
                </FormGroup>
              </Col>
              <Col lg={colOverrides.nominee_identity || 6} className="ps-0">
                <FormGroup>
                  <Label for="nominee_document">
                    Identity Document upload- png, jpeg, jpg (PAN or Driving
                    Licence or Aadhaar)*
                  </Label>
                  <Input
                    type="file"
                    name="nominee_document"
                    id="nominee_document"
                    innerRef={fileInputRef}
                    className="form-control"
                    accept="image/png, image/jpg, image/jpeg"
                    onChange={(e) => {
                      const file = e.currentTarget.files[0];
                      formik.setFieldValue("nominee_document", file);
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_document &&
                      formik.errors.nominee_document
                    }
                  />
                  {isInModal && formik.values.nominee_document?.name && (
                    <div className="mt-1 text-muted">
                      {formik.values.nominee_document.name}
                    </div>
                  )}
                  <FormFeedback>{formik.errors.nominee_document}</FormFeedback>
                </FormGroup>
              </Col>
              <Col
                lg={colOverrides.nominee_identity || 6}
                className={
                  colOverrides.nominee_identity_class || "ps-0 ps-lg-3"
                }
              >
                <FormGroup>
                  <Label for="nominee_identity">
                    Identity No. (last 4 digit of uploaded document) *
                  </Label>
                  <Input
                    type="text"
                    name="nominee_identity"
                    id="nominee_identity"
                    className="form-control"
                    placeholder="Enter last 4 digits of ID"
                    maxLength="4"
                    pattern="\d*"
                    value={formik.values.nominee_identity}
                    onChange={(e) => {
                      // Allow only digits
                      const value = e.target.value;
                      if (/^\d{0,4}$/.test(value)) {
                        formik.setFieldValue("nominee_identity", value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_identity &&
                      formik.errors.nominee_identity
                    }
                  />
                  <FormFeedback>{formik.errors.nominee_identity}</FormFeedback>
                </FormGroup>
              </Col>
            </>
          ) : (
            <>
              <Col
                lg={colOverrides.nominee_identity || 6}
                className={
                  colOverrides.nominee_identity_class || "ps-0 ps-lg-3"
                }
              >
                <FormGroup>
                  <Label for="nominee_identity">
                    Identity No. (last 4 digit of document) *
                  </Label>
                  <Input
                    type="text"
                    name="nominee_identity"
                    id="nominee_identity"
                    className="form-control"
                    placeholder="Enter last 4 digits of ID"
                    maxLength="4"
                    pattern="\d*"
                    value={formik.values.nominee_identity}
                    onChange={(e) => {
                      // Allow only digits
                      const value = e.target.value;
                      if (/^\d{0,4}$/.test(value)) {
                        formik.setFieldValue("nominee_identity", value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_identity &&
                      formik.errors.nominee_identity
                    }
                  />
                  <FormFeedback>{formik.errors.nominee_identity}</FormFeedback>
                </FormGroup>
              </Col>
              <Col lg={12} className="ps-0">
                <FormGroup>
                  <Label for="nominee_document">
                    Identity Document upload- png, jpeg, jpg (PAN or Driving
                    Licence or Aadhaar)*
                  </Label>
                  <Input
                    type="file"
                    name="nominee_document"
                    id="nominee_document"
                    className="form-control"
                    accept="image/png, image/jpg, image/jpeg"
                    onChange={(e) => {
                      const file = e.currentTarget.files[0];
                      formik.setFieldValue("nominee_document", file);
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_document &&
                      formik.errors.nominee_document
                    }
                  />
                  {isInModal && formik.values.nominee_document?.name && (
                    <div className="mt-1 text-muted">
                      {formik.values.nominee_document.name}
                    </div>
                  )}
                  <FormFeedback>{formik.errors.nominee_document}</FormFeedback>
                </FormGroup>
              </Col>

              <Col lg={12} className="ps-0">
                <FormGroup>
                  <Label for="nominee_address">Address *</Label>
                  <Input
                    type="text"
                    name="nominee_address"
                    id="nominee_address"
                    className="form-control"
                    placeholder="Enter address"
                    value={formik.values.nominee_address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_address &&
                      formik.errors.nominee_address
                    }
                  />
                  <FormFeedback>{formik.errors.nominee_address}</FormFeedback>
                </FormGroup>
              </Col>
            </>
          )}

          <div className="row m-0 p-0">
            <Col lg={6} className="mb-3 ps-0">
              <Label className="form-label" htmlFor="is_minor">
                Nominee is minor ?
              </Label>

              <div id="is_minor">
                <FormGroup check inline className="">
                  <Input
                    type="radio"
                    name="is_minor"
                    id="otherYes"
                    value="1"
                    checked={formik.values.is_minor === "1"}
                    onChange={(e) => {
                      formik.handleChange(e); // Handle the radio button change
                      // No need to clear fields when selecting "Yes"
                    }}
                    onBlur={formik.handleBlur}
                  />
                  <Label check htmlFor="otherYes">
                    Yes
                  </Label>
                </FormGroup>
                <FormGroup check inline className="ms-3">
                  <Input
                    type="radio"
                    name="is_minor"
                    id="otherNo"
                    value="0"
                    checked={formik.values.is_minor === "0"}
                    onChange={(e) => {
                      formik.handleChange(e); // Handle the radio button change
                      // Clear conditional fields when selecting "No"
                      if (e.target.value === "0") {
                        formik.setFieldValue("nominee_dob", "");
                        formik.setFieldValue("nominee_gaurdian", "");
                        // Clear any existing errors for these fields
                        formik.setFieldError("nominee_dob", undefined);
                        formik.setFieldError("nominee_gaurdian", undefined);
                      }
                    }}
                    onBlur={formik.handleBlur}
                  />
                  <Label check htmlFor="otherNo">
                    No
                  </Label>
                </FormGroup>
              </div>
            </Col>
          </div>
          {formik.values.is_minor == "1" && (
            <>
              <Col lg={6} className="ps-0">
                <FormGroup>
                  <Label for="nominee_gaurdian">Guardian </Label>
                  <Input
                    type="text"
                    name="nominee_gaurdian"
                    id="nominee_gaurdian"
                    className="form-control"
                    placeholder="Enter guardian name"
                    value={formik.values.nominee_gaurdian}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.nominee_gaurdian &&
                      formik.errors.nominee_gaurdian
                    }
                  />

                  <FormFeedback>{formik.errors.nominee_gaurdian}</FormFeedback>
                </FormGroup>
              </Col>
              <Col lg={6} className="ps-0 ps-lg-3">
                <FormGroup>
                  <Label for="nominee_dob">DOB </Label>
                  <div className="position-relative">
                    {/* Icon inside input */}
                    <i
                      className="bx bx-calendar date-icon"
                      style={{
                        position: "absolute",
                        left: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#6c757d",
                        fontSize: "18px",
                      }}
                    />
                    <Flatpickr
                      id="nominee_dob"
                      name="nominee_dob"
                      className={`form-control ${
                        formik.touched.nominee_dob && formik.errors.nominee_dob
                          ? "is-invalid"
                          : ""
                      }`}
                      style={{ paddingLeft: "2.5rem" }}
                      placeholder="Select date"
                      value={formik.values.nominee_dob}
                      onChange={(date) => {
                        formik.setFieldValue("nominee_dob", date[0] || "");
                        formik.setFieldTouched("nominee_dob", true);
                      }}
                      options={{
                        dateFormat: "d-m-Y",
                        maxDate: "today",
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  {(formik.touched.nominee_dob || formik.submitCount > 0) &&
                    formik.errors.nominee_dob && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.nominee_dob}
                      </div>
                    )}
                </FormGroup>
              </Col>
            </>
          )}
        </Row>
        {!isInModal && (
          <Col xxl={12} className="ps-0">
            <div className="d-flex align-items-center justify-content-start">
              <Button
                type="button"
                color="primary"
                onClick={handleAddNominee}
                disabled={nomineeList?.length >= 10}
              >
                Add Nominee
              </Button>
            </div>
          </Col>
        )}
      </Form>
      {/* table of add nominee */}
      {nomineeList?.length > 0 && (
        <div className="table-responsive px-0 my-3">
          <Table hover className="align-middle table-nowrap table-bordered">
            <thead className="bg-gl-primary sticky-header">
              <tr>
                {columns?.map((col, idx) => (
                  <th
                    key={idx}
                    style={{
                      padding: "0.4rem",
                      textAlign: "center",
                      maxWidth: "200px",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {nomineeList.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {columns.map((col, colIdx) => (
                    <td
                      key={colIdx}
                      className="fw-medium"
                      style={{
                        textAlign: col.key === "index" ? "center" : "start",
                      }}
                    >
                      {col.key === "index" ? (
                        `${rowIdx + 1}.`
                      ) : col.key === "nominee_document" ? (
                        row.nominee_document?.name || "N/A"
                      ) : col.key === "action" ? (
                        <div className="d-flex justify-content-center gap-2">
                          <i
                            className="ri-edit-box-line text-primary cursor-pointer fs-18"
                            title="Edit"
                            onClick={() => handleEditNominee(rowIdx)}
                          ></i>
                          <i
                            className="ri-delete-bin-line text-danger cursor-pointer fs-18"
                            title="Delete"
                            onClick={() => {
                              setEditIndex(rowIdx);
                              setConfirm_modal(true);
                            }}
                          ></i>
                        </div>
                      ) : col.key === "nominee_dob" ? (
                        row.nominee_dob ? (
                          new Date(row.nominee_dob).toLocaleDateString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            }
                          )
                        ) : (
                          "-"
                        ) 
                        ) : col.key === "nominee_relationship" ? (
                          relationshipOptions?.find(
                            (opt) => String(opt.value) === String(row.nominee_relationship)
                          )?.label || "-"
                        ) : (
                          row[col.key] || "-"
                        )
                        }
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {/* modal for confirmation */}
      {confirm_modal && (
        <ConfirmationModal
          confirm_modal={confirm_modal}
          close_confirmModal={close_confirmModal}
          title={"Delete Nominee Detail"}
          bodyContent={
            "Are you sure you want to delete this nominee's details?"
          }
          cancelText={"No"}
          confirmText={"Yes"}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
    </>
  );
};

export default NomineeFormFields;
